import { render, staticRenderFns } from "./QuickActions.vue?vue&type=template&id=4a5a2d71&scoped=true"
import script from "./QuickActions.vue?vue&type=script&lang=js"
export * from "./QuickActions.vue?vue&type=script&lang=js"
import style0 from "./QuickActions.vue?vue&type=style&index=0&id=4a5a2d71&prod&lang=scss"
import style1 from "./QuickActions.vue?vue&type=style&index=1&id=4a5a2d71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a2d71",
  null
  
)

export default component.exports